import findBlockSettingComments from '../utils/helpers/find-block-setting-comments';

const areChildrenEnabledForNode = (liveNode, childrenSelector) => {
  if (liveNode && liveNode.querySelector(childrenSelector)) {
    return true;
  }

  if (findBlockSettingComments(liveNode, childrenSelector).length > 0) {
    return false;
  }

  return false;
};

export default areChildrenEnabledForNode;
